import { getServiceDeskRequestBody } from './utils/commonUtils';

const { CABS_FQDN } = process.env;
const DEFAULT_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

export const quickBookAPIResponse = async req => {
  const apiCall = await fetch(`${CABS_FQDN}/search/quickbook`, {
    method: 'POST',
    body: JSON.stringify(req),
    DEFAULT_HEADERS
  });
  const response = await apiCall.json();
  return response;
};

export const assistFormApiCall = async req => {
  const url = `${CABS_FQDN}/v1/assistedFlow/formSubmit`;
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(req),
    DEFAULT_HEADERS
  });
  const parsedResponse = await response.json();
  return parsedResponse;
};

export const logRttApiCall = async req => {
  try {
    const url = `${CABS_FQDN}/metrics/log-rtt`;
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(req),
      headers: DEFAULT_HEADERS
    });
  } catch (err) {
    console.error('error in logRttApiCall');
  }
};

export const fetchUgcReviews = async (
  sourceCityLobCode,
  destinationCityLobCode
) => {
  // const { DATA_LOADER_URL } = process.env;
  // console.log('DATA_LOADER_URL', DATA_LOADER_URL);
  // const url = `${DATA_LOADER_URL}/api/route/ugcReviews?sourceCityLobCode=${sourceCityLobCode}&destinationCityLobCode=${destinationCityLobCode}`;
  // const response = await fetch(url);
  // const data = await response.json();
  // return data;
};

export const makeServiceDeskRequest = async (reqId, pageName) => {
  const request = getServiceDeskRequestBody(reqId, pageName);
  try {
    const url = `${CABS_FQDN}/my-desk-request/create`;
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(request),
      headers: DEFAULT_HEADERS
    });
  } catch (error) {
    console.log('Error in service desk request: ', error);
  }
};

export const getXdmEventData = async req => {
  const url = `${CABS_FQDN}/api/seo-xdm-payload`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(req),
      headers: DEFAULT_HEADERS
    });

    if (!response.ok) {
      console.error(
        `getXdmEventData: Received non-OK response (${response.status})`
      );
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error('getXdmEventData: Fetch failed', error);
    return null;
  }
};
